import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ErrorMessageDirective } from '../../misc/directives/error-message.directive';
import { MiscModule } from '../../misc/misc.module';
import { ReferralPageRoutingModule } from './referral-routing.module';
import { ReferralPageComponent } from './referral.page';

@NgModule({
  declarations: [ReferralPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    ReferralPageRoutingModule,
    MiscModule,
    NgOptimizedImage,
    ErrorMessageDirective
  ]
})
export class ReferralPageModule {}
